import { FC } from 'react';
import Head from 'next/head';

interface ISocialMediaMetadata {
  title?: string;
  description?: string;
  keywords?: string;
  url?: string;

  // facebook
  ogimage?: string;
  ogimagewidth?: string;
  ogimageheight?: string;

  // twitter
  twimage?: string;
  small?: boolean;
}

export const SocialMediaMetadata: FC<ISocialMediaMetadata> = ({
  title = 'Versum',
  description = 'Next-gen NFT platform and metaverse',
  keywords = 'versum,marketplace,metaverse,tezos,nft,cleannft',
  url = 'https://versum.xyz',
  ogimage = 'https://versum.xyz/facebook.jpg',
  ogimagewidth = '1200',
  ogimageheight = '630',
  twimage = 'https://versum.xyz/twitter.jpg',
  small = false,
}) => {
  return (
    <Head>
      {/* generic */}

      <title>{title}</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />

      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* facebook */}
      <meta property="og:title" content={title} key="ogtitle" />
      <meta property="og:url" content={url} key="ogurl" />
      <meta property="og:image" content={ogimage} key="ogimage" />
      <meta property="og:image:secure_url" content={ogimage} key="ogimagesecure" />
      <meta property="og:image:width" content={ogimagewidth} key="ogwidth" />
      <meta property="og:image:height" content={ogimageheight} key="ogheight" />
      <meta property="og:description" content={description} key="ogdescription" />
      <meta property="og:site_name" content={title} key="ogsitename" />

      {/* twitter */}
      <meta name="twitter:card" {...(small ? { content: 'summary' } : { content: 'summary_large_image' })} />
      <meta name="twitter:site" content="@versumofficial" />
      <meta name="twitter:creator" content="@versumofficial" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={twimage} />
      <meta name="twitter:image:alt" content={description} />
    </Head>
  );
};
